import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import SportsTrainingPost from "../../../components/sports-training-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Beginner",
    frequency: "2 to 3 easy sessions",
    focus: "Run-walk rhythm, relaxed form, consistency, confidence",
    weeklyHabit: "Keep most running easy enough to finish feeling good",
  },
  {
    level: "Developing runner",
    frequency: "3 to 4 sessions",
    focus: "Easy runs, strides, hills, basic strength, mobility",
    weeklyHabit: "Add variety gradually and avoid increasing everything at once",
  },
  {
    level: "Competitive runner",
    frequency: "4 to 6 sessions",
    focus: "Intervals, tempo, long run, strength, race pacing",
    weeklyHabit: "Separate hard days with easy or rest days",
  },
  {
    level: "Advanced runner",
    frequency: "5 to 7 sessions with recovery",
    focus: "Training cycles, race-specific work, load management, recovery",
    weeklyHabit: "Track sleep, soreness, and intensity alongside distance",
  },
]

const sections = [
  {
    title: "Beginner: make consistency easy",
    paragraphs: [
      "Beginner running should start with comfortable run-walk sessions, relaxed posture, easy breathing, and enough rest to want to come back.",
      "The first goal is not speed. It is building a repeatable habit without soreness taking over the week.",
    ],
  },
  {
    title: "Developing runner: add variety slowly",
    paragraphs: [
      "Developing runners can add strides, short hills, mobility, and simple strength while keeping most running easy. Variety helps, but sudden jumps in distance and intensity do not.",
      "A good week might include two easy runs, one light workout, one longer relaxed run, and one or two strength or mobility blocks.",
    ],
  },
  {
    title: "Competitive runner: protect the easy days",
    paragraphs: [
      "Competitive runners need intervals, tempo work, long runs, strength, drills, and recovery. The hard sessions only work if the easy days are genuinely easy.",
      "Use a calendar to mark workout days, race days, long runs, and rest so intensity is spread across the week.",
    ],
  },
  {
    title: "Advanced runner: manage the full cycle",
    paragraphs: [
      "Advanced running routines should plan training blocks, race-specific workouts, deload weeks, strength, mobility, and recovery. Distance alone does not tell the whole story.",
      "Track sleep, soreness, mood, and effort. Those signals often reveal when the plan needs an easier day before performance drops.",
    ],
  },
]

const RunningTrainingRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Running Training Schedule by Skill Level"
        description="Plan running training for beginners, developing runners, competitive runners, and advanced athletes with routines for easy runs, workouts, strength, and recovery."
      />
      <SportsTrainingPost
        sport="Running"
        title="Running training routines for different levels"
        intro="A strong running routine builds consistency first, then adds speed, strength, race-specific work, and recovery at the right pace."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/soft-seahorse-29"
        image="blog-running.png"
        imageAlt="Running training planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default RunningTrainingRoutines
